import React, { useState } from 'react';
import { FaArrowLeft, FaDownload, FaPrint, FaSave } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import LoginModal from './LoginModal';
import { loginModal } from '../../../Redux/authAction'; 

const ConfirmationDialog = ({ show, onClose, onConfirm }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex z-50 items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-bold mb-4">Confirm Exit</h2>
        <p className="mb-6">Are you sure you want to exit? Unsaved changes may be lost.</p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-purple-600 text-white hover:bg-purple-700 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded bg-purple-600 text-white hover:bg-purple-700 transition-colors"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

const Navbar = ({ handleDownload, handlePrint, saveToLocalStorage }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.authReducer.isAuthenticated);
  const loginModalOpen = useSelector((state) => state.authReducer.loginModal);

  const [showDialog, setShowDialog] = useState(false);

  const handleHomeClick = () => {
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  const handleConfirmDialog = () => {
    setShowDialog(false);
    navigate('/');
  };

  const handleProtectedAction = (action) => {
    if (isAuthenticated) {
      action();
    } else {
      dispatch(loginModal(true));
    }
  };

  return (
    <>
      <nav className="w-full flex justify-between items-center px-6 py-2 bg-purple-600 text-white shadow-lg">
        <div className="flex items-center space-x-6">
          <button
            onClick={handleHomeClick}
            className="flex items-center text-md font-semibold hover:text-gray-300 transition-colors"
          >
            <FaArrowLeft className="mr-2" /> Home
          </button>
        </div>
        <div className="flex items-center space-x-4">
          <button
            onClick={() => handleProtectedAction(saveToLocalStorage)}
            className="flex items-center text-md font-semibold hover:text-gray-300 transition-colors"
          >
            <FaSave className="mr-2" /> Save
          </button>
          <button
            onClick={() => handleProtectedAction(handleDownload)}
            className="flex items-center px-4 py-2 rounded-xl bg-purple-800 hover:bg-purple-500 transition-colors text-md font-semibold"
          >
            <FaDownload className="mr-2" /> Download
          </button>
          <button
            onClick={() => handleProtectedAction(handlePrint)}
            className="flex items-center px-4 py-2 rounded-xl bg-purple-800 hover:bg-purple-500 transition-colors text-md font-semibold"
          >
            <FaPrint className="mr-2" /> Print
          </button>
        </div>
      </nav>

      {/* Confirmation dialog when user clicks Home */}
      <ConfirmationDialog
        show={showDialog}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmDialog}
      />

      {/* Login Modal */}
      <LoginModal
        open={loginModalOpen}
        onClose={() => dispatch(loginModal(false))}
      />
    </>
  );
};

export default Navbar;
